<template>
  <div class="container mx-auto">
    <div class="mb-6">
      <div class="flex justify-between mb-4">
        <div class="flex-1 min-w-0">
          <router-link to="/" class="inline-flex text-gray-700 hover:text-gray-900 border px-4 py-1 rounded text-xs border-gray-600 hover:bg-gray-300">Regresar a lista de empleados</router-link>
        </div>
        <div class="flex">
          <span class="px-4 text-xs font-medium text-gray-800 bg-gray-200 border rounded-md border-transparent py-1">{{ this.$route.params.nombreempleado }}</span>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-9">
        <h4 class="font-semibold text-xl text-gray-800 mb-6">Nomina</h4>
      </div>
      <div class="col-span-3 justify-self-end">
        <NavExpediente :registroEmpleado="this.$route.params.nombreempleado" :empleadoId="this.$route.params.id" />
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mb-8">
      <div class="col-span-3">
        <router-link :to="{ name: 'nomina-nuevo', params: { id: this.$route.params.id, nombreempleado: this.$route.params.nombreempleado } }" class="bg-blue-500 hover:bg-blue-600 text-white text-xs py-2 px-8 rounded focus:outline-none focus:shadow-outline mr-auto">Registrar ajuste nomina</router-link>
      </div>
    </div>
    <div class="col-span-9">
        <h4 class="font-medium text-base text-gray-500 mb-2">Ajustes Nomina</h4>
      </div>
    <ListAjustesNomina :ajustes="ajustes" class="mb-6"/>
    <Pagination :count="ajustesCount" :activePage="activePage" @onChangePage="cambiarPaginacion" />
  </div>
</template>

<script>
import NavExpediente from '@/components/NavExpediente'
import authClient from '@/utils/auth'
import ListAjustesNomina from '@/components/ListAjustesNomina'
import Pagination from '@/components/Pagination'
export default {
  name: 'EmpleadoNomina',
  components: {
    NavExpediente,
    ListAjustesNomina,
    Pagination
  },
  data () {
    return {
      ajustes: [],
      ajustesCount: 0,
      activePage: 0
    }
  },
  methods: {
    obtenerAjustesNomina () {
      this.$http.post('/api/turno-ajustes/ajuste-empleado', { empleado: this.$route.params.id, page: this.activePage }, {
        headers: {
          Authorization: authClient.getAuthToken()
        }
      }).then(({ data }) => (this.ajustes = data))
      this.$http.post('/api/turno-ajustes/ajuste-empleado-count', { empleado: this.$route.params.id }, {
        headers: {
          Authorization: authClient.getAuthToken()
        }
      }).then(({ data }) => (this.ajustesCount = data))
    },
    cambiarPaginacion (pageSelected) {
      this.activePage = pageSelected
      this.obtenerAjustesNomina()
    }
  },
  mounted () {
    this.obtenerAjustesNomina()
  }
}
</script>
